<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :items-per-page="perPage"
    :mobile-breakpoint="0"
    :height="height"
    fixed-header
    hide-default-footer>
    <template #[`header.name`]="{ header }">
      <div class="d-flex">
        <v-tooltip
          content-class="tooltip-bottom"
          color="#373D3F"
          nudge-right="122"
          transition="fade-transition"
          bottom>
          <template #activator="{ on, attrs }">
            <span class="mr-1">{{ header.text }}</span>
            <v-icon
              v-bind="attrs"
              class="cs-help"
              color="secodary"
              size="14"
              v-on="on">
              mdi-alert-circle-outline
            </v-icon>
          </template>
          <v-card
            max-width="200"
            color="transparent"
            flat
            dark>
            แสดงชื่อสินค้าและจำนวนสินค้าคงเหลือ ซึ่งเป็นยอดที่รวมจาก จำนวนของสินค้าย่อย
          </v-card>
        </v-tooltip>
        <v-spacer />
        ราคา
      </div>
    </template>
    <template #[`item.thumbUrl`]="{ item }">
      <snt-thumb-img
        :src="item.thumbUrl"
        width="60"
        height="60"
        contain />
    </template>
    <template #[`item.code`]="{ item }">
      <v-tooltip
        :disabled="item.code.length < 12"
        color="#373D3F"
        transition="fade-transition"
        bottom>
        <template #activator="{ on, attrs }">
          <div
            :style="{maxWidth: '100px'}"
            v-bind="attrs"
            class="text-overflow--1"
            v-on="on">
            {{ item.code }}
          </div>
        </template>
        <v-card
          max-width="200"
          color="transparent"
          flat
          dark>
          {{ item.code }}
        </v-card>
      </v-tooltip>
    </template>
    <template #[`item.name`]="{ item }">
      <div class="d-flex gap-1 mb-2">
        <v-tooltip
          :disabled="item.name.length < 16"
          color="#373D3F"
          transition="fade-transition"
          bottom>
          <template #activator="{ on, attrs }">
            <div
              v-bind="attrs"
              class="text-overflow--1"
              v-on="on">
              {{ item.name }}
            </div>
          </template>
          <v-card
            max-width="300"
            color="transparent"
            flat
            dark>
            {{ item.name }}
          </v-card>
        </v-tooltip>
        <v-spacer />
        {{ item.salePrice | toLocaleStringDecimal }}
      </div>
      <div
        v-for="(subItem) in item.options"
        :key="`tb-product-sub-${subItem.id}`"
        class="d-flex gap-1 align-center mb-3">
        <v-badge
          :value="getCount(subItem)"
          :content="getCount(subItem)"
          color="primary"
          offset-x="10"
          offset-y="10">
          <v-btn
            :disabled="getCount(subItem) >= subItem.available"
            color="primary"
            outlined
            small
            @click="pick({ ...subItem, product: item})">
            <v-icon left>
              mdi-plus-circle
            </v-icon>
            <div class="d-flex gap-1">
              <span
                :style="{ maxWidth: '120px' }"
                class="text-overflow--1"> {{ subItem.name }} </span>
              <template v-if="hideStock">
                <span
                  v-if="subItem.available"
                  class="sub-product-available">(มีของ)</span>
                <span
                  v-else
                  class="sub-product-available">(ไม่มีของ)</span>
              </template>
              <span
                v-else
                class="sub-product-available">({{ subItem.available }})</span>
            </div>
          </v-btn>
        </v-badge>
        <v-spacer />
        <div v-if="subItem.salePrice !== item.salePrice">
          {{ subItem.salePrice | toLocaleStringDecimal }}
        </div>
      </div>
    </template>
    <template #footer>
      <snt-pagination
        v-if="productList.pagesCount > 1"
        v-model="page"
        :total-visible="7"
        :total-pages="productList.pagesCount" />
    </template>
  </v-data-table>
</template>

<script>
import { GET_PRODUCT_LIST } from '@/resources/graphql'
import ProductModel from '@/assets/js/model/product'

export default {
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    searchText: {
      type: String,
      default: ''
    },
    stockId: {
      type: String,
      default: null
    },
    unitPrice: {
      type: [String, Number],
      default: 'price'
    },
    hideStock: Boolean,
    knockable: Boolean
  },
  apollo: {
    productList: {
      fetchPolicy: 'network-only',
      query: GET_PRODUCT_LIST,
      variables () {
        return {
          page: this.page,
          perPage: this.perPage,
          search: this.searchText,
          stockId: this.stockId
        }
      }
    }
  },
  data () {
    return {
      page: 1,
      perPage: 20,
      productList: {
        pagesCount: 0,
        nodesCount: 0,
        nodes: []
      },
      headers: [
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'thumbUrl',
          cellClass: 'vertical-align-top',
          class: 'grey--text'
        },
        {
          text: 'รหัสสินค้า',
          align: 'left',
          sortable: false,
          value: 'code',
          cellClass: 'vertical-align-top',
          class: 'grey--text'
        },
        {
          text: 'ชื่อสินค้า (จำนวน)',
          align: 'left',
          sortable: false,
          class: 'grey--text',
          cellClass: 'vertical-align-top',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    items () {
      return this.productList.nodes.map((item) => new ProductModel({ ...item, unitPrice: this.unitPrice }))
    },
    selectedItems () {
      return this.$_.cloneDeep(this.value)
    },
    filteredSelectedItems () {
      return this.selectedItems.filter((item) => !item._destroy)
    },
    height () {
      return this.$vuetify.breakpoint.mobile ? '100%' : 'calc(100vh - 500px)'
    }
  },
  watch: {
    stockId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.page = 1
      }
    },
    searchText (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.page = 1
      }
    }
  },
  methods: {
    getCount (option) {
      const selectedItems = this.filteredSelectedItems.filter((it) => it.id === option.id)
      return selectedItems.reduce((total, item) => total + item.quantity, 0)
    },
    pick (item) {
      let selectedItems = this.$_.cloneDeep(this.selectedItems)
      if (this.knockable) {
        selectedItems = this.$_.knockAllWith(selectedItems, {
          ...item,
          stockId: this.stockId,
          quantity: 1
        }, (a, b) => a.id === b.id)
      } else {
        const selectedItem = selectedItems.find((it) => it.id === item.id && it.salePrice === item.salePrice)
        if (selectedItem) {
          selectedItem.quantity += 1
        } else {
          selectedItems.push({
            ...item,
            stockId: this.stockId,
            quantity: 1
          })
        }
      }

      this.$emit('input', selectedItems)
    }
  }
}
</script>

<style lang="scss" scoped>
  .sub-product-available {
    color: #F0B26C;
  }
  .v-data-table {
    ::v-deep {
      .v-data-table__wrapper {
        padding-right: 8px;
        &> table > tbody > tr > td {
          padding-top: 12px;
          padding-bottom: 16px;
        }
      }
    }
  }
</style>
